<template>
    <div class="development">
        <headers :title="$t('发展历程')" img="development"></headers>
        <div class="development_Main">
            <div class="development_Top">
                <div class="development_Top_circle">
                    <div class="year">2015</div>
                </div>
                <div class="development_Top_line"></div>
                <div class="development_Top_circle">
                    <div class="year">2018</div>
                </div>
                <div class="development_Top_line"></div>
                <div class="development_Top_circle">
                    <div class="year">2020</div>
                </div>
                <div class="development_Top_line"></div>
                <div class="development_Top_circle">
                    <div class="year">{{$t('未来')}}</div>
                </div>
                <div class="mark" :style="`transform: translate(${mark1Left}%,-50%)`"></div>
            </div>
            <div class="development_Center">
                <div class="development_CenterList">
                    <transition name="fade">
                        <div v-show="center1" class="development_Center_year">
                            <div class="development_Center_year_cricle">
                                <div class="year">2015</div>
                            </div>
                            <div class="text">
                                <div class="month">{{$t('201501月')}}</div>
                                <div class="line"></div>
                                <div class="txt">{{$t('誉诚成立')}}</div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-show="center2" class="highLine"></div>
                    </transition>

                    <transition name="fade">
                        <div v-show="center3" class="development_Center_year">
                            <div class="development_Center_year_cricle">
                                <div class="year">2018</div>
                            </div>
                            <div class="text">
                                <div class="month">{{$t('201805月')}}</div>
                                <div class="line"></div>
                                <div class="txt">{{$t('成立子公司河南富凯防护制品有限公司')}}</div>
                            </div>
                        </div>
                    </transition>

                    <transition name="fade">
                        <div v-show="center4" class="highLine"></div>
                    </transition>

                    <transition name="fade">
                        <div v-show="center5" class="development_Center_year">
                            <div class="development_Center_year_cricle">
                                <div class="year">2020</div>
                            </div>
                            <div class="text">
                                <div class="month">{{$t('202001月')}}</div>
                                <div class="line"></div>
                                <div class="txt">{{$t('征地70亩进行新厂房扩规扩建')}}</div>
                            </div>
                        </div>
                    </transition>
                    
                    <transition name="fade">
                        <div v-show="center6" class="highLine"></div>
                    </transition>

                    <transition name="fade">
                        <div v-show="center7" class="development_Center_year">
                            <div class="development_Center_year_cricle">
                                <div class="year">{{$t('未来')}}</div>
                            </div>
                            <div class="text">
                                <div class="month" style="width:1.8rem;">···</div>
                                <div class="line"></div>
                                <div class="txt">{{$t('创造更多可能')}}</div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-show="center8" class="highLine" style="height:3rem;"></div>
                    </transition>
                </div>
            </div>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";

export default {
    components:{
        headers,foot
    },
    data() {
        return {
            mark1Left:-50,
            mark1Top:0,
            center1:false,
            center2:false,
            center3:false,
            center4:false,
            center5:false,
            center6:false,
            center7:false,
            center8:false,
        }
    },
    methods:{
        showList(){
            this.mark1Left = 100
            this.mark1Top = 100
            this.center1 = true
            setTimeout(()=>{
                this.center2 = true
            },300)  
            setTimeout(()=>{
                this.center3 = true
            },600)  
            setTimeout(()=>{
                this.center4 = true
            },900)  
            setTimeout(()=>{
                this.center5 = true
            },1200)  
            setTimeout(()=>{
                this.center6 = true
            },1500)  
            setTimeout(()=>{
                this.center7 = true
            },1800)  
            setTimeout(()=>{
                this.center8 = true
            },2100)  
        }
    },
    mounted(){
        setTimeout(()=>{
            this.showList()
        },1000)
    }
}
</script>
<style lang="less">
.development{
    width: 100%;
    @media (max-width: 1024px) {
        .development_Main{
            width: 90%;
        }
    }
    @media (min-width: 1024px) {
        .development_Main{
            width: 50%;
        }
    }
    .development_Main{
        padding-top: 5rem;
        padding-bottom: 5rem;
        margin: 0 auto;
        min-height: 800px;
        .development_Center{
            width: 100%;
            margin-top: 3rem;
            position: relative;
            .mark2{
                width: 120%;
                height: 100%;
                background-color: #fff;
                position: absolute;
                left: 50%;
                top: 0;
                transform: translate(-50%,0);
                transition: 3s all linear;
            }
            .highLine{
                width: 1px;
                height: 6rem;
                background-color: #007ba8;
            }
            .development_Center_year{
                display: flex;
                align-items: center;
                .development_Center_year_cricle{
                    border: 1px solid #007ba8;
                    width: 5vw;
                    height: 5vw;
                    border-radius: 2.5rem;
                    position: relative;
                    flex-grow: 0;
                    flex-shrink: 0;
                    transform: translateX(-50%);
                    .year{
                        font-size: 1.5rem;
                        color: #007ba8;
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translate(110%,-50%);
                        font-weight: 550;
                    }
                    
                }
                .text{
                    display: flex;
                    align-items: center;
                    font-size: 0.8rem;
                    margin-left: 6rem;
                    .month{
                        color: #919191;
                        text-align: center;
                    }
                    .txt{
                        color: #4d4d4d;
                    }
                    .line{
                        width: 1px;
                        height: 1.2rem;
                        background-color: #9e9e9e;
                        margin: 0 2rem;
                    }

                }
                .development_Center_year_cricle::after{
                    content: '';
                    position: absolute;
                    width: 1vw;
                    height: 1vw;
                    border-radius: 50%;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%,-50%);
                    background-color: #007ba8;
                }
            }
        }
        .development_Top{
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            transform: translate(-0.5vw,0);
            .mark{
                width: 120%;
                height: 5vw;
                background-color: #fff;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                transition: 3s all linear;
            }
            .development_Top_circle{
                width: 1vw;
                height: 1vw;
                position: relative;
                border-radius: 50%;
                background-color: #76b8d0;
                flex-grow: 0;
                .year{
                    position: absolute;
                    width: 3rem;
                    text-align: center;
                    left: 50%;
                    font-size: 0.8rem;
                    color: #007ba8;
                    top: 0;
                    transform: translate(-50%,-100%);
                }
            }
            .development_Top_line{
                background-color: #9e9e9e;
                height: 1px;
                width: 100px;
                flex-grow: 1;                
            }
            .development_Top_circle::after{
                content: "";
                width: 0.5vw;
                height: 0.5vw;
                background-color: #017ca8;
                position: absolute;
                left: 50%;
                border-radius: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
            }
        }
    }
}
</style>
<i18n>
{
  "en": {
      "发展历程":"Development Path",
      "未来":"Future",
      "月":"month",
      "誉诚成立":"Yucheng established",
      "成立子公司河南富凯防护制品有限公司":"Established Henan Fukai Protective Products Co., Ltd.",
      "征地70亩进行新厂房扩规扩建":"Requisitioning 70 mu of land for new plant expansion",
      "创造更多可能":"Create more possibilities",
      "201501月":"Jan",
      "201805月":"May",
      "202001月":"Jan"   
  },
  "zh": {
      "发展历程":"发展历程",
      "未来":"未来",
      "月":"月",
      "誉诚成立":"誉诚成立",
      "成立子公司河南富凯防护制品有限公司":"成立子公司河南富凯防护制品有限公司",
      "征地70亩进行新厂房扩规扩建":"征地70亩进行新厂房扩规扩建",
      "创造更多可能":"创造更多可能",
      "201501月":"01月",
      "201805月":"05月",
      "202001月":"01月"      
  }
}
</i18n>
